var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 47.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03045e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "waveBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,413.16l6.5-1.87c6.5-1.91,19.5-5.66,32.5-5.07s26,5.5,39,5.27,26-5.74,39.2-5.54,26.5,6,39.6,8.66S183,416.56,196,416s26-1.13,39-1.25,26,.12,39-.89,26-3.4,39-4.18,26,0,39,1.09,26,2.54,39,1.45,26-4.76,39.2-6.24,26.5-.86,39.6.78,26.2,4.21,39.2,4,26-3.4,39-5.35,26-2.73,39-.58,26,7.21,39,7.1,26-5.47,39-7.1,26,.46,39,2.41,26,3.75,39.2,3.05,26.5-4,39.6-5.66,26.2-1.83,39.2.59,26,7.33,39,7.88,26-3.4,32.5-5.35l6.5-1.95V451H0Z",
    transform: "translate(0 -403.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBack);
export default __webpack_public_path__ + "static/media/waveBack.dcf18dc86184c8f3c982b62456ecd47d.svg";
export { ForwardRef as ReactComponent };